if (!customElements.get('mobile-floating-cart')) {
  customElements.define('mobile-floating-cart', class extends HTMLElement {
    connectedCallback() {
      this.requestId = 0;
      this.onPageShow = () => this.refresh();
      window.addEventListener('pageshow', this.onPageShow);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }

    disconnectedCallback() {
      this.requestId++;
      window.removeEventListener('pageshow', this.onPageShow);
      if (this.unsubscribe) this.unsubscribe();
    }

    async refresh() {
      const requestId = ++this.requestId;
      try {
        const response = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (!this.isConnected || requestId !== this.requestId || !Number.isInteger(cart.item_count)) return;
        const badge = this.querySelector('[data-cart-count]');
        const link = this.querySelector('[data-cart-link]');
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
        link.setAttribute('aria-label', `カート、商品 ${cart.item_count}点`);
      } catch (error) {
        console.warn('カートの数量を更新できませんでした。', error);
      }
    }
  });
}
